/* Moved verbatim out of sections/gift-builder.liquid (2026-10-05) to keep the section under Shopify's 256 KB cap. Loaded synchronously at the same position. */
function gbFireConfetti() {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var wrap = document.getElementById('gb-confetti');
  if (!wrap) return;
  var colors = ['#a85e38','#2d6b5e','#f2ede4','#1e2535','#d4896a'];
  var style = document.getElementById('gb-confetti-keyframes');
  if (!style) {
    style = document.createElement('style');
    style.id = 'gb-confetti-keyframes';
    style.textContent = '@keyframes gb-fall{0%{transform:translate3d(0,-20px,0) rotate(0deg);opacity:1}100%{transform:translate3d(0,110vh,0) rotate(var(--gb-rot,360deg));opacity:0}}';
    document.head.appendChild(style);
  }
  var frag = document.createDocumentFragment();
  for (var i = 0; i < 60; i++) {
    var el = document.createElement('div');
    var size = Math.random() * 8 + 4;
    var color = colors[Math.floor(Math.random() * colors.length)];
    var left = Math.random() * 100;
    var rot = Math.random() * 720 - 360;
    var dur = Math.random() * 1.5 + 2;
    el.style.cssText = 'position:absolute;top:-20px;left:' + left + '%;width:' + size + 'px;height:' + size + 'px;background:' + color + ';border-radius:' + (Math.random() > 0.5 ? '50%' : '2px') + ';--gb-rot:' + rot + 'deg;animation:gb-fall ' + dur + 's ease-in forwards;';
    frag.appendChild(el);
  }
  wrap.appendChild(frag);
  setTimeout(function() {
    wrap.innerHTML = '';
    var s = document.getElementById('gb-confetti-keyframes');
    if (s) s.remove();
  }, 3500);
}


(function(){
  var c = document.getElementById('gb-hero-stars');
  if (!c) return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;
  var ctx = c.getContext('2d');
  var stars = [], t = 0, rafId = null;
  var hero = c.closest('.gb-hero');
  function isVisible() {
    return c.offsetWidth > 0 && c.offsetHeight > 0;
  }
  function resize() {
    var w = c.offsetWidth;
    var h = c.offsetHeight;
    if (!w || !h) {
      stop();
      return;
    }
    c.width = w; c.height = h;
    stars = [];
    for (var j = 0; j < Math.floor(c.width * 0.12); j++) {
      stars.push({
        x: Math.random() * c.width,
        y: Math.random() * c.height,
        r: Math.random() * 1.1 + 0.2,
        baseO: Math.random() * 0.35 + 0.05,
        speed: Math.random() * 0.012 + 0.003,
        phase: Math.random() * Math.PI * 2
      });
    }
    start();
  }
  function draw() {
    rafId = null;
    if (!isVisible()) return;
    ctx.clearRect(0, 0, c.width, c.height);
    stars.forEach(function(s) {
      var a = Math.max(0, s.baseO + Math.sin(t * s.speed + s.phase) * 0.12);
      ctx.beginPath();
      ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255,255,255,' + a + ')';
      ctx.fill();
    });
    t++;
    rafId = requestAnimationFrame(draw);
  }
  function start() {
    if (!rafId && isVisible()) rafId = requestAnimationFrame(draw);
  }
  function stop() {
    if (rafId) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
  }
  resize();
  window.addEventListener('resize', resize);
  if (window.ResizeObserver) {
    new ResizeObserver(resize).observe(c);
    if (hero) new ResizeObserver(resize).observe(hero);
  }
})();
